"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PHONE = void 0;
exports.PHONE = {
    ADD_PHONE: "ADD-PHONE",
    SET_PRIMARY_PHONE: "SET-PRIMARY-PHONE",
    DELETE_PHONE: "DELETE-PHONE",
    MAKE_PRIMARY_PHONE: "MAKE-PRIMARY-PHONE",
    VALIDATE_CONFIRMATION_CODE: "VALIDATE-CONFIRMATION-CODE",
    RESEND_CONFIRMATION_CODE: "RESEND-CONFIRMATION-CODE",
};
